import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const AboutSection = styled.section`
  min-height: 100vh;
  background: #121212;
  color: white;
  padding: 8rem 2rem 4rem;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding: 6rem 1rem 2rem;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4rem;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const GoalsBox = styled(motion.div)`
  background: #ff6b00;
  padding: 2rem;
  border-radius: 8px;
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    aspect-ratio: auto;
    padding: 1.5rem;
  }
`;

const GoalsTitle = styled.h2`
  font-size: 2.5rem;
  margin: 0;
  font-weight: 600;
  color: white;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const GoalsArrow = styled.div`
  font-size: 4rem;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Paragraph = styled(motion.p)`
  font-size: 1.2rem;
  line-height: 1.6;
  color: #999;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const About = () => {
  return (
    <AboutSection>
      <Container>
        <Content>
          <GoalsBox
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <GoalsTitle>ABOUT</GoalsTitle>
            <GoalsArrow>↗</GoalsArrow>
          </GoalsBox>
          <TextContent>
            <Paragraph
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Our goal is to elevate the immersion of racing simulation. We provide an excellent yet affordable sim racing experience by delivering both quality hardware and endless innovations.
            </Paragraph>
            <Paragraph
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              What began as the enthusiasm of passionate DIY builders and sim racers has transformed into a well-engineered product for serious and pro sim racing gamers like you.
            </Paragraph>
            <Paragraph
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              The RSR team consists of 3 individuals that are based in Indonesia.
            </Paragraph>
          </TextContent>
        </Content>
      </Container>
    </AboutSection>
  );
};

export default About;
